import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export function useQueryParams<TParsedQuery = any>() {
    const location = useLocation();
    const queryString = require('query-string');
    return useMemo<TParsedQuery>(() => queryString.parse(location.search), [location.search, queryString]);
}
